import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ViewEncapsulation
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AccountState } from '../../../../store/reducers/account.reducer';
import { Account } from '@smmof/entity';
import { selectAccountState } from '../../../../store/selectors/account.selectors';

@Component({
  selector: 'header-user',
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="flex items-center">
      <ng-container *ngIf="isAuthenticated; else notAuthenticated">
        <!-- Шаблон для авторизованного пользователя -->
        <button class='mr-5' routerLink='/account/settings' mat-button>
          <img
            class="w-7 h-7 rounded-full"
            *ngIf="showAvatar && user?.avatar"
            [src]="user?.avatar"
          />
          <mat-icon
            *ngIf="!showAvatar || !user?.avatar"
            [svgIcon]="'heroicons_outline:user-circle'"
            class="text-gray-500"
          ></mat-icon>
          <span class="flex items-center leading-none ml-2">
            <span>{{ user?.name }}</span>
          </span>
        </button>
        <!-- Кнопка возврата в платформу -->
        <button class="btn btn-small btn-green inline-flex" [routerLink]="['/dashboard/onboarding']">
          Вернуться в платформу
        </button>
      </ng-container>
    </div>

    <ng-template #notAuthenticated>
      <!-- Шаблон для неавторизованного пользователя -->
      <button class="btn btn-small btn-green inline-flex mr-5" [routerLink]="['/sign-in']">
        Войти
      </button>
      <button class="btn btn-small btn-border inline-flex max-lg:hidden" [routerLink]="['/sign-up']">
        Зарегистрироваться
      </button>
    </ng-template>
  `,
})
export class HeaderUserComponent implements OnInit, OnDestroy {
  user: Account | null = null;
  isAuthenticated: boolean = false;
  showAvatar: boolean = true;
  private _unsubscribeAll = new Subject<void>();

  constructor(
    private _store: Store<{ account: AccountState }>,
    private _changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this._store
      .select(selectAccountState)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((state: AccountState) => {
        this.user = state.account;
        this.isAuthenticated = state.isAuthenticated;
        // Маркируем для проверки
        this._changeDetectorRef.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
